import React from 'react'
import './Card.css';

export const Card = (props) => {
    
    let { type, bordered, className, ...other} = props;
    
    className = `card ${type ? `card--${type}` : ''} ${bordered ? ' card--bordered' : ''} ${ props.className || ''}` ;
    
    return (
        <>        
            <div {...other} className={className}>
                <div className='card__content'>
                    {props.children}
                </div>
            </div>
        </>
    )
}